import { NavLink } from 'react-router-dom';
import type { RecentWorkItem } from './recent-work';

interface SidebarProps {
  machineId: string | null;
  machineName: string | null;
  canViewOrganization?: boolean;
  canViewUsers?: boolean;
  canSwitchOrganization?: boolean;
  recentWork?: RecentWorkItem[];
}

export function Sidebar({ machineId, machineName, canViewUsers = false, recentWork = [] }: SidebarProps) {
  return (
    <aside className="r42-sidebar">
      {machineId ? (
        <>
          <div className="r42-sidebar-machine">
            <span className="r42-eyebrow">Current machine</span>
            <strong>{machineName ?? 'Machine'}</strong>
          </div>
          <NavLink className="r42-new-conversation" to={`/machines/${machineId}/conversations/new`} end>
            <i className="bi bi-plus-lg" aria-hidden="true" /> New conversation
          </NavLink>
          <nav className="r42-nav" aria-label="Machine navigation">
            <span className="r42-nav-label">Workspace</span>
            <NavItem to={`/machines/${machineId}`} icon="bi-gear-wide-connected" label="Machine" end />
            <NavItem to={`/machines/${machineId}/conversations`} icon="bi-chat-left-text" label="Conversations" />
            <NavItem to={`/machines/${machineId}/investigations`} icon="bi-search" label="Investigations" />
            <NavItem to={`/machines/${machineId}/documents`} icon="bi-file-earmark-text" label="Documents" />
            <NavItem to={`/machines/${machineId}/memory`} icon="bi-cpu" label="Machine Memory" />
            <NavItem to={`/machines/${machineId}/activity`} icon="bi-clock-history" label="Activity" />
            <span className="r42-nav-label r42-nav-label--secondary">Machines</span>
            <NavItem to="/machines" icon="bi-gear-wide-connected" label="All machines" end />
          </nav>
        </>
      ) : (
        <nav className="r42-nav" aria-label="Application navigation">
          <span className="r42-nav-label">Route42</span>
          <NavItem to="/machines" icon="bi-gear-wide-connected" label="Machines" end />
          <NavItem to="/organizations" icon="bi-building" label="Change Organization" />
          {canViewUsers ? <NavItem to="/settings/users" icon="bi-people" label="Users & access" /> : null}
          <span className="r42-nav-label r42-nav-label--secondary">Recent</span>
          {recentWork.length ? (
            <div className="r42-recent-work" aria-label="Recently opened work">
              {recentWork.map((item) => (
                <NavLink key={item.href} to={item.href} className="r42-recent-work__link" title={`${item.machineName} · ${item.title}`} aria-label={`${item.title} ${item.machineName}`}>
                  <i className="bi bi-clock-history" aria-hidden="true" />
                  <span><strong>{item.title}</strong><small>{item.machineName}</small></span>
                </NavLink>
              ))}
            </div>
          ) : <p className="r42-recent-work__empty">Work you open on a machine will appear here.</p>}
        </nav>
      )}
    </aside>
  );
}

function NavItem({ to, icon, label, end = false }: { to: string; icon: string; label: string; end?: boolean }) {
  return (
    <NavLink className={({ isActive }) => `r42-nav-item${isActive ? ' active' : ''}`} to={to} end={end}>
      <i className={`bi ${icon}`} aria-hidden="true" /> {label}
    </NavLink>
  );
}
